import { Injectable } from '@angular/core'
import { Observable, forkJoin, map, of } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'
import { ProductsService } from '../../products/services/products.service'

@Injectable({
  providedIn: 'root',
})
export class InterventionRescheduleService {
  private apiUrl = environment.apiUrl

  constructor(
    private http: HttpClient,
    private productsService: ProductsService
  ) {}

  /**
   * Replanifie une intervention existante
   * @param data Données de replanification
   */
  reschedule(data: any): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/interventions/${data.interventionId}/reschedule`,
      data
    )
  }

  /**
   * Récupère les dates disponibles pour la replanification d'une intervention
   * @param interventionId ID de l'intervention
   * @param erpSource Source ERP
   */
  getAvailableDates(
    interventionId: number,
    erpSource: string
  ): Observable<any> {
    return this.http.get(
      `${this.apiUrl}/interventions/${interventionId}/available-dates`,
      {
        params: { erpSource },
      }
    )
  }

  /**
   * Récupère et normalise les produits d'une intervention pour assurer la cohérence
   * des données utilisées dans la replanification.
   * @param intervention Intervention avec les produits
   * @param mlRef Référence ML de l'affaire
   */
  getAndNormalizeInterventionProducts(
    intervention: any,
    mlRef: string
  ): Observable<any[]> {
    if (
      !intervention?.affairProducts ||
      intervention.affairProducts.length === 0
    ) {
      return of([])
    }

    // Récupérer tous les produits disponibles pour l'affaire
    return this.productsService.getSchedulableProductsByMlRef(mlRef, true).pipe(
      map((allProducts) => {
        // Créer une carte pour rechercher efficacement les produits par ID
        const productMap = new Map()
        allProducts.forEach((product) => {
          productMap.set(product.id, product)
        })

        // Normaliser chaque produit de l'intervention avec les données complètes
        return intervention.affairProducts.map((product: any) => {
          const fullProduct = productMap.get(product.id)
          if (fullProduct) {
            return {
              ...fullProduct,
              quantity: product.quantity || 1,
            }
          }
          return product
        })
      })
    )
  }
}
